<div cdkDropListGroup class="boards-list">
  @for (kanbanGroup of kanbanGroups; track $index) {
    <iu-kanban-board-ui
      [columnsDisplayAD]="this.columnsDisplayAD"
      [container]="this.container"
      [isCollapsed]="isCollapsed"
      [isFlexDesign]="kanbanGroups.length === 1"
      [kanbanGroup]="kanbanGroup"
      [kanbanImageColumn]="this.kanbanImageColumn"
      [tabId]="tabId"
      [tableName]="tableName"
      [(draggedElement)]="draggedElement"
      (changeGroupEmitter)="queryDataStore()"
      (clickEmitter)="clickEmitter.emit($event)" />
  }
</div>
